module.exports = __webpack_public_path__ + "static/img/main_sub_menu03.31126707.svg";